/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PressKitLogoExtensionEnum {
    Jpg = 'jpg',
    Png = 'png'
}


export function PressKitLogoExtensionEnumFromJSON(json: any): PressKitLogoExtensionEnum {
    return PressKitLogoExtensionEnumFromJSONTyped(json, false);
}

export function PressKitLogoExtensionEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitLogoExtensionEnum {
    return json as PressKitLogoExtensionEnum;
}

export function PressKitLogoExtensionEnumToJSON(value?: PressKitLogoExtensionEnum | null): any {
    return value as any;
}

